// extracted by mini-css-extract-plugin
module.exports = {"caseStudies":"case-studies-module--case-studies--1rrGw","caseStudies__item":"case-studies-module--case-studies__item--OLLtK"};